// ThemeCard.tsx
import React from 'react';

type ThemeCardProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'compact' | 'elevated';
  padding?: 'none' | 'sm' | 'md' | 'lg';
};

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
};

const variantClasses = {
  default: 'bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-100 dark:border-gray-700',
  compact: 'bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700',
  elevated: 'bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700'
};

export const ThemeCard: React.FC<ThemeCardProps> = ({ 
  children, 
  className = '', 
  variant = 'default',
  padding = 'md'
}) => {
  return (
    <div className={`${variantClasses[variant]} ${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
};

